:host {
    display:block;

    /**
    * @prop --font-family-regular: Regular font. Default value --font-klavika-regular.
    * @prop --font-family-medium: Medium font. Default value --font-klavika-medium.
    * @prop --color-primary: Primary color for links, headlines and buttons
    * @prop --color-button: Button color. Default set to primary-color
    * @prop --color-button-hover: Button color hover state
    * @prop --color-button-text: Button text color
    * @prop --color-category: Color of category. Default is set to --color-secondary-mustard
    * @prop --color-focus: Color of focus state (border) of elements
    * @prop --color-divider: Divider color default is set to --color-tertiary-grey
    * @prop --color-meta-text: Meta information text. Default color is set to --color-tertiary-warmgrey
    */
    --font-family-regular: var(--font-klavika-regular, sans-serif);
    --font-family-medium: var(--font-klavika-medium, sans-serif);
    --color-primary: rgb(var(--color-adesso-primary-blue));
    --color-button: var(--color-primary);
    --color-button-text: rgb(255,255,255);
    --color-button-hover: rgb(var(--color-adesso-blue-3));
    --color-category: rgb(var(--color-secondary-mustard));
    --color-focus: var(--color-category);
    --color-divider: rgb(var(--color-tertiary-grey));
    --color-meta-text: rgb(var(--color-tertiary-warmgrey));
}

* {
    box-sizing:border-box;
    font-family:var(--font-family-regular, sans-serif);
}

@keyframes spin {
    0% {
        transform: rotate(0);
    }
    100% {
        transform: rotate(360deg);
    }
}

#searchResults {
    position:relative;
}

.date-author time::after {
    content:" | ";
    display:inline-block;
    margin-inline-start:.5rem;
    margin-inline-end:.5rem;
}

.date-author [itemprop="author"]:not(:last-child)::after {
    content: ", ";
}

/* Styles for Teaser */

.blog-teaser {
    position:absolute;
    opacity:0;
    transition:all .3s ease;
}

/* Loading Style for Teaser */
#searchResults .blog-teaser.show:not(.loading .show) {
    opacity:1;
}

.loading .blog-teaser  {
    opacity:.3;
}

header {
    display:flex;
    flex-direction:column-reverse;
}

a {
    text-decoration:none;
    color:var(--color-primary);
}

.meta {
    color:var(--color-meta-text);
    flex:3;
    align-items:center;
}

.meta p {
    margin:0;
}

.meta i {
    vertical-align:middle;
}

.heading a {
    font-size:1.6rem;
    color:var(--color-primary);
    font-family:var(--font-family-medium);
}

/* Experimental Hover Effect */

a {
    position:relative;
    display:block;
}

a::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 100%;
    background-color: rgba(255,255,255,0.4);
    transition: none;
}

a:hover {
    color:var(--color-button-hover);
    transition: all 0.4s ease-in-out;
}

a:hover:after {
    width: 120%;
    background-color: rgba(255,255,255,0);
    transition: all 0.4s ease-in-out;
}

figure {
    margin:.5rem;
}

.flex {
    display:flex;
    align-items:center;
}

.r-reverse {
    flex-direction:row-reverse;
}

.category {
    color:var(--color-category);
}

img {
    border-radius:50%;
    width:100px;
}

.heading {
    font-size:1.5rem;
    line-height:1.2;
    margin-block-start:0;
}	

footer {
    padding-block-end: 2rem;
    border-block-end: 1px solid var(--color-divider);
}

.uppercase {
    text-transform:uppercase;
}

/* Filter */
.result-filter-container {
    margin-bottom:2rem;
    color:black;
}

#blogContainer {
    container-type:inline-size;
    color:black;
    transform-style: preserve-3d;
}

#filtercontainer {
    display:flex;
    gap:1rem;
    flex-wrap:wrap;
    justify-content:space-between;
    height:0;
    opacity:0;
    margin-block-end:1rem;
    transition:all .2s linear;
}

#filtercontainer > div, #filtercontainer > ad-select  {
    flex:20%;
}

#filtercontainer.active {
    height:100%;
    opacity:1;
}

.filtertoggle {
    display:flex !important;
    align-items:center;
    cursor:pointer;
    min-width:200px;
    font-family: var(--font-family-regular);
    font-size: 1rem;

    background:transparent;
    border-radius:0;
    border:1px solid transparent;
    padding:0;
}

.filtertoggle > ad-icon  {
    margin-inline-end:1rem;
    background: var(--color-primary);
    color:white;
    aspect-ratio:1/1;
    height:auto;
    width:50px;
    display:flex;
    align-items:center;
    justify-content:center;
}

.filter-meta {
    display:flex;
    align-items:center;
    margin-block-start:1rem;
    margin-block-end:1rem;
    flex-direction:row;
}

[disabled] {
    filter: grayscale(100%);
    opacity:0.8;
    cursor:not-allowed !important;
}

.selectbox-container {
    position: relative;
}

button:focus {
    outline:none;
    border: solid 1px var(--color-focus);
}


#resultContainer {
    width:100%;
}

.meta-info {
    text-align:right;
    width:100%;
}

em, .totalResults {
    color:var(--color-primary);
    font-style:normal;
    font-weight:normal;
    font-family:var(--font-family-medium);
}

/* Loader */
.loading #loader {
    display:block;
}

#loader {
    display: none;
    position: relative;
    width: 40px;
    height: 40px;
    margin:0 auto;
}

#loader:before {
    content: "";
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 2px solid transparent;
    border-top-color: var(--color-primary);
    animation: spin 0.8s linear infinite;
}

/* Error Handling */
.error {
    display:flex;
    flex-direction: column;
    align-items:center;
    margin-block-end:1rem;
    text-align:center;
}

.error .headline {
    font-size:clamp(2rem, 4dvw, 3rem);
    color:var(--color-primary);
}

@container (max-width:800px) {
    .result-filter-container.r-reverse  {
        flex-direction:column-reverse;
    }

    #filtercontainer > div {
        flex:100%;
    }

    .filter-meta {
        flex-direction:column-reverse;
        align-items:start;
    }

    .meta-info {
        text-align:center;
    }
}